import { Editor } from "primereact/editor";

interface HtmlTextEditorProps {
  value: string;
  onChange: (html: string) => void;
}

export function HtmlTextEditor({ value, onChange }: HtmlTextEditorProps) {
  const header = (
    <span className="ql-formats">
      <select className="ql-header">
        <option value="1">H1</option>
        <option value="2">H2</option>
        <option value="3">H3</option>
        <option value="">Normal</option>
      </select>

      <button className="ql-bold" />
      <button className="ql-italic" />
      <button className="ql-underline" />
      <button className="ql-strike" />

      <button className="ql-list" value="ordered" />
      <button className="ql-list" value="bullet" />

      <button className="ql-align" value="" />
      <button className="ql-align" value="center" />
      <button className="ql-align" value="right" />

      <button className="ql-link" />

      <button className="ql-code-block" />
      <button className="ql-clean" />
    </span>
  );

  return (
    <div
      className="
        border rounded-xl overflow-hidden
        bg-background text-foreground
        [&_.ql-toolbar]:border-b
        [&_.ql-toolbar]:border-border
        [&_.ql-toolbar]:bg-muted/50
        dark:[&_.ql-toolbar]:bg-muted
        [&_.ql-container]:border-0
        [&_.ql-editor]:min-h-[280px]
        [&_.ql-editor]:bg-background
        [&_.ql-editor]:text-foreground
        [&_.ql-editor]:placeholder:text-muted-foreground
        [&_.ql-editor]:focus:outline-none
      "
    >
      <Editor
        value={value}
        onTextChange={e => onChange(e.htmlValue ?? "")}
        headerTemplate={header}
        style={{ height: "280px" }}
        placeholder="Write your content here..."
      />
    </div>
  );
}
